module.exports = __webpack_public_path__ + "static/media/biathlon.4e91377d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/biathlon.svg
// module id = 365
// module chunks = 7